<template>
  <div class="brandLine">
    <div>
      <span class="title">{{ $t("common.brands") }}</span>
      <span class="stitle">{{ $t("home.brandsSettled") }}</span>
    </div>
    <div class="brandList pr-95" id="brandList1">
      <div
        class="brandItem"
        v-for="(item, index) in showList[0]"
        :key="index"
        @click="getgoodsByBrand(item.brandId)"
      >
        <el-image class="img" lazy :src="item.fileUrl || defaultImg" :fit="'contain'">
          <div slot="error">
            <el-image class="img" :src="defaultImg" :fit="'contain'"> </el-image>
          </div>
        </el-image>
      </div>
    </div>
    <div class="brandList pl-95" id="brandList2">
      <div
        class="brandItem"
        v-for="(item, index) in showList[1]"
        :key="index"
        @click="getgoodsByBrand(item.brandId)"
      >
        <el-image class="img" lazy :src="item.fileUrl || defaultImg" :fit="'contain'">
          <div slot="error">
            <el-image class="img" :src="defaultImg" :fit="'contain'"> </el-image>
          </div>
        </el-image>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      defaultImg: require('@/assets/img/bitmap.png'),
      brandList: [], // 品牌列表
      //   控制滚动速度
      offset: 3
    }
  },
  computed: {
    showList () {
      const len = Math.ceil(this.brandList.length / 2)
      return [this.brandList.slice(0, len), this.brandList.slice(len)]
    }
  },
  created () {
    this.getBrandList()
  },
  methods: {
    getgoodsByBrand (brandId) {
      this.$router.push({
        name: 'goodSearchCategoryList',
        query: {
          foregroundCategoryId: '',
          brandIdList: brandId + '',
          seriesIdList: '',
          attributeValueIdList: '',
          salesDesc: false,
          priceDesc: false,
          popularityDesc: false,
          category: true
        }
      })
    },
    // 获取品牌
    getBrandList () {
      this.$request.get(`/front/cross/commodity-user/web/brand-list`).then((data) => {
        this.brandList = data ? data.slice(0, 200) : []
        this.$nextTick(() => {
          this.startRoll()
        })
      })
    },
    startRoll () {
      const brandList1 = document.getElementById('brandList1')
      const brandList2 = document.getElementById('brandList2')
      console.dir(brandList1)
      const w1 = brandList1.scrollWidth
      const c1 = brandList1.clientWidth

      setInterval(() => {
        const l1 = brandList1.scrollLeft
        if (l1 + c1 >= w1) {
          this.offset = -1
        }
        if (l1 <= 0) {
          this.offset = 1
        }
        brandList1.scrollLeft += this.offset
        brandList2.scrollLeft += this.offset
      }, 10)
    }
  }
}
</script>

<style lang="scss" scoped>
.brandLine {
  .title {
    font-family: Alibaba PuHuiTi;
    font-size: 24px;
    font-weight: 700;
    line-height: 32.93px;
    text-align: left;
    color: #333;
  }
  .stitle {
    font-family: Alibaba PuHuiTi;
    font-size: 16px;
    font-weight: 400;
    line-height: 21.95px;
    text-align: left;
    color: #666;
  }
  .brandList {
    overflow-x: scroll;
    white-space: nowrap;
    height: 120px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  .brandItem {
    width: 190px;
    height: 100px;
    border: 2px solid #f6f5fa;
    border-radius: 16px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    margin-right: 12px;
    // flex-grow: 1;
    flex-shrink: 0;
    .img {
      height: 96px;
    }
  }
  .pl-95 {
    padding-left: 95px;
  }
  .pr-95 {
    padding-right: 95px;
  }
}
</style>
